import React from 'react';

// Add the newest release first. Keep entries concise and link to a blog article when a release needs more detail.
const releases = [
  {
    version: 'v1.0.0',
    dateTime: '2026-08-09',
    date: 'August 9, 2026',
    summary: 'Promptera is now publicly available. Start with the Free Trial and bring your team’s prompt work into one shared workspace.',
    changes: [
      'Public launch of Promptera for creating, testing, refining, versioning, and sharing prompts and AI work.',
      'Free Trial with 500 credits for model usage, so you can get started without bringing an API key.',
      'Shared workspaces, collaboration, prompt version control, and Prompt DNA.',
      'Multi-model testing (Limited to low cost OpenAI models), prompt enhancement, and agent sessions.',
      'Guided onboarding for workspaces, Explorer, prompt editing, testing, versioning, search, and settings.'
    ]
  }
];

export default function ChangelogPage(){
  return (
    <main className="changelog-page">
      <section className="changelog-hero" aria-labelledby="changelog-title">
        <div className="container">
          <p className="changelog-kicker">Product releases</p>
          <h1 id="changelog-title">Changelog</h1>
          <p>A clear record of what changes in Promptera with every release.</p>
        </div>
      </section>

      <section className="changelog-section" aria-label="Promptera product changelog">
        <div className="container changelog-list">
          {releases.length ? releases.map((release) => (
            <article className="changelog-entry glass" key={release.version}>
              <div className="changelog-entry-meta">
                <h2>{release.version}</h2>
                <time dateTime={release.dateTime}>{release.date}</time>
              </div>
              <p>{release.summary}</p>
              <ul>
                {release.changes.map((change) => <li key={change}>{change}</li>)}
              </ul>
            </article>
          )) : (
            <article className="changelog-empty glass">
              <p className="changelog-empty-label">Coming with the next release</p>
              <h2>Release notes will live here.</h2>
              <p>Each entry will capture what is new, improved, and fixed in Promptera.</p>
            </article>
          )}
        </div>
      </section>
    </main>
  );
}
